<template>
    <div class="modal fade modal-confirmRegister" id="confirmRegister" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- Modal body -->
                <div class="modal-body">
                    <label
                        v-if="!utils.isCooperator()"
                        @click="backEditTourInfo"
                        data-dismiss="modal"
                        data-toggle="modal"
                        style="font-size:12px;"
                    >◀<u>{{ $t('voucher.modal-registerDmos.backEditTour') }}</u></label>

                    <div class="center-modal">
                        <div class="miniTourInfo" v-if="showTour">
                            <details>
                                <summary class="title">団体名情報はここをタップ</summary>
                                <div class="row">
                                    <label class="cnt-title">{{ $t('tour.tour_number') }}</label>
                                    <label class="cnt-item">{{ tourInfo.tour_number }}({{ storageService.getCashName() }})</label>
                                </div>

                                <div class="row">
                                    <label class="cnt-title">{{ $t('tour.precheck.tour_name') }}</label>
                                    <label class="cnt-item">{{ tourInfo.name }}</label>
                                </div>

                                <div class="row">
                                    <label class="cnt-title">{{ $t('tour.precheck.schedule') }}</label>
                                    <label class="cnt-item">{{ dateUtils.formatDualDate(tourInfo.departure_date, tourInfo.return_date) }}</label>
                                </div>

                                <div class="row">
                                    <label class="cnt-title">{{ $t('tour.person_count') }}</label>
                                    <label class="cnt-item">{{ utils.formatTourCount(tourInfo) }}</label>
                                </div>

                                <div class="row">
                                    <label class="cnt-title"></label>
                                    <label class="cnt-item">{{ utils.personTourCount(tourInfo) }}</label>
                                </div>
                            </details>
                        </div>



                        <div v-if="summarys" class="cnt-slider">
                            <div class="lst-slider">
                                <slick class="slider-row slick" ref="slick_preChecks" :options="summarySlickOptions">
                                    <li v-for="item in summarys" :key="item.currency_id">
                                        <div class="box-news">
                                            <div class="box-heading">
                                                <div class="precheck-title">{{ $t('summary.preCheck') }}</div>
                                                <div class="unit-date">{{ utils.getCurrencyName(item.currency_id) }}</div>
                                            </div>
                                            <div class="summary-preChecks">
                                                <div class="cnt-group" v-if="tourInfo.tour_type==constants.TourType.international.id && item.exchanges">
                                                    <div class="cnt-item summaryttl">
                                                        <div class="ttl ttl-label">{{ $t('cash.exchange') }}</div>
                                                    </div>
                                                    <div class="cnt-item">
                                                        <div class="ttl">{{ $t('summary.label.initial_carry_cash') }}</div>
                                                        <div class="num">{{ item.exchanges.initial_carry_cash ? utils.formatPrice(item.exchanges.initial_carry_cash) : '-' }}</div>
                                                    </div>
                                                    <div class="cnt-item">
                                                        <div class="ttl">{{ $t('summary.label.exchange_in') }}</div>
                                                        <div class="num">{{ item.exchanges.exchange_in ? utils.formatPrice(item.exchanges.exchange_in) : '-' }}</div>
                                                    </div>
                                                    <div class="cnt-item">
                                                        <div class="ttl">{{ $t('summary.label.exchange_out') }}</div>
                                                        <div class="num">{{ item.exchanges.exchange_out ? utils.formatPrice(item.exchanges.exchange_out) : '-' }}</div>
                                                    </div>
                                                    <div class="cnt-item group-total">
                                                        <div class="ttl ttl-label">{{ $t('summary.label.deduction') }}</div>
                                                        <div class="num">{{ item.exchanges.deduction ? utils.formatPrice(item.exchanges.deduction) : '-' }}</div>
                                                    </div>
                                                </div>

                                                <div class="cnt-group">
                                                    <div class="cnt-item summaryttl">
                                                        <div class="ttl ttl-label">{{ $t('cash.list_carry') }}</div>
                                                    </div>
                                                    <div class="cnt-item">
                                                        <div class="ttl">{{ $t('summary.label.carry_cash') }}</div>
                                                        <div class="num">{{ utils.formatPrice(item.carry_cashs.carry_cash) }}</div>
                                                    </div>
                                                    <div class="cnt-item">
                                                        <div class="ttl">{{ $t('cash.expenditure') }}</div>
                                                        <div class="num">{{ utils.formatPrice(item.carry_cashs.expenditure) }}</div>
                                                    </div>
                                                    <div class="cnt-item">
                                                        <div class="ttl">{{ $t('cash.income') }}</div>
                                                        <div class="num">{{ utils.formatPrice(item.carry_cashs.income) }}</div>
                                                    </div>
                                                    <div class="cnt-item group-total">
                                                        <div class="ttl ttl-label">{{ $t('cash.remaining') }}</div>
                                                        <div class="num">{{ utils.formatPrice(item.carry_cashs.remaining) }}</div>
                                                    </div>
                                                </div>

                                                <div class="cnt-group">
                                                    <div class="cnt-item summaryttl">
                                                        <div class="ttl ttl-label">{{ $t('summary.local_income') }}</div>
                                                    </div>
                                                    <div class="cnt-item">
                                                        <div class="ttl">{{ $t('summary.label.deposit_income') }}</div>
                                                        <div class="num">{{ utils.formatPrice(item.local_incomes.total != null ? item.local_incomes.total : 0 , item.currency_id) }}</div>
                                                    </div>
                                                </div>

                                                <div class="cnt-group">
                                                    <div class="cnt-item all-total">
                                                        <div class="ttl ttl-label">{{ $t('summary.label.totalbalance') }}</div>
                                                        <div class="num">{{ utils.formatPrice(item.total, item.currency_id) }}</div>
                                                    </div>
                                                </div>

                                                <div class="cnt-group diastamp">
                                                    <div class="cnt-item" v-if="tourInfo.tour_type!=constants.TourType.international.id">
                                                        <div class="ttl ttl-label">{{ $t('summary.label.diastamp') }}</div>
                                                        <div class="num">{{ item.local_incomes.diastamps != null ? item.local_incomes.diastamps : 0 }}{{ $t('voucher.general.sheet') }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </slick>
                            </div>
                        </div>

                        <div v-if="!utils.isCooperator()" class="center-ttl font300 d-flex justify-content-center">
                            <i class="icon-upload-orange mr-2"></i>
                            <span class="font500 text-pink">
                                {{ $t('voucher.modal-registerDmos.register') }}
                            </span>しますか？
                        </div>
                        <div v-if="!utils.isCooperator()" class="center-ttl d-flex justify-content-center">
                            <span class="text-preview"
                                @click="downloadExcel"
                            >
                                <i class="icon-preview"></i>
                                {{ $t('voucher.modal-registerDmos.preview') }}
                            </span>
                        </div>
                        <div class="row no-gutters" v-if="utils.isReadOnly()">
                            <div class="col-12 pl-2">
                                <button class="btn btn-gray-44 w-100" @click=onClickCancel>閉じる</button>
                            </div>
                        </div>
                        <div class="row no-gutters" v-else>
                            <div v-if="!utils.isCooperator()" class="col-6 pr-2">
                                <button
                                    class="btn btn-pink-44 w-100 ex-orange-light"
                                    data-dismiss="modal"
                                    data-toggle="modal"
                                    @click="exportExcel"
                                >OK</button>
                            </div>

                            <div class="col-6 pl-2">
                                <button class="btn btn-gray-44 w-100" @click="onClickCancel">{{ $t('button.cancel') }}</button>
                            </div>
                        </div>
                        <div v-if="!utils.isCooperator()" class="row no-gutters" style="height:1.3rem">
                            <p v-if="utils.isReadOnly()" style="font-size:12px; margin-top: 1rem">※本画面を閉じると前画面で修正した情報は破棄されます。</p>
                            <p v-else style="font-size:12px; margin-top: 1rem">※キャンセルすると前画面で修正した情報は破棄されます。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Utils from "@/helpers/utils";
import DateUtils from "@/helpers/dateUtils";
import {Constants } from "@/helpers/constants";
import StorageService from "@/services/common/storage.service";

export default {
    name: "SpConfirmRegsiter",
    props: {
        summarys: "",
        summarySlickOptions: {},
        tourInfo: "",
    },
    components: {
        Slick
    },
    data () {
        return {
            utils: Utils,
            dateUtils: DateUtils,
            constants: Constants,
            showTour: false,
            storageService: StorageService,
        };
    },
    beforeMount () {
    },
    methods: {
        downloadExcel () {
            this.$emit('downloadExcel');
        },
        exportExcel () {
            this.$emit('exportExcel');
        },
        backEditTourInfo () {
            this.$emit('backEditTourInfo');
        },
        onClickCancel () {
            this.$emit('onClickCancel');
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/views/components/sp/Voucher/ConfirmRegisterModal.vue